export default __webpack_public_path__ + "static/media/i051jp.aff64931.webp";